import * as THREE from 'three';
import Fragment from './Fragment';
import Translate from './Translate';

export default class ImageFragment extends Fragment {
  constructor(params) {
    super(params);
    this.offset = Math.random();
    // this.hide = false;
  }
  randomPosition(position = this.position) {
    const p = position.clone();
    p.x += 0.5;
    super.randomPosition(p);

    // Position
    this.endPosition = this.width > this.height ? new THREE.Vector3(
      (Math.sign(this.startPosition.x) * (Math.random() + 0.15) * Translate.FOV.width) / 2,
      0,
      0,
    ) : new THREE.Vector3(
      0,
      (Math.sign(this.startPosition.y) * (Math.random() + 0.15) * Translate.FOV.height) / 2,
      0,
    );

    this.position.copy(this.endPosition);
  }
  update(params) {
    super.update(params);

    const { offset, repeat } = params;

    this.hide = false;

    if (
      ((offset.x === 0 || offset.x + repeat.x === 1) && repeat.x < 0.2 && repeat.y < 0.2) ||
      ((offset.y === 0 || offset.y + repeat.y === 1) && repeat.y < 0.2 && repeat.x < 0.2) ||
      (
        (offset.x === 0 || offset.x + repeat.x === 1) &&
        (offset.y === 0 || offset.y + repeat.y === 1) &&
        repeat.y < 0.4 &&
        repeat.x < 0.4
      )
    ) {
      this.hide = true;
    }
  }
  translate(translate = 0) {
    let scalar = 0;

    if (translate >= this.offset) {
      scalar = (translate - this.offset) / (1 - this.offset);
    }

    super.translate(scalar);
  }
  animate(animation) {
    const { rotation, slide, expulse, opacity } = animation;
    super.animate({
      ...animation,
      rotation: Math.min(rotation, 1),
      opacity: this.hide ? 0 : opacity,
    });
    this.position.x -= slide * 2;
    this.position.y += Math.max(expulse - 0.34, 0) * 15;
  }
}



// WEBPACK FOOTER //
// ./src/scene/Object/ImageFragment.js